import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";

//UI
import { Button, Modal, Table, Loader, Input, Segment, Header, Message, Icon } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import HeaderCatalog from "../../../components/headerCatalog";

//Actions
import { fetchCountries } from "../../../redux/actions/catalogs/country/fetchCountries";
import { deleteCountry } from "../../../redux/actions/catalogs/country/deleteCountry";

// Resources
import { scrollToTop } from "../../resources/utils";

export default function CountryList() {
  const { t } = useTranslation();
  const countryState = useSelector((state) => state.countryReducer);
  const dispatch = useDispatch();
  const { register, getValues } = useForm();
  const [sortedCountries, setSortedCountries] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });


  useEffect(() => {
    dispatch(fetchCountries(""));
    scrollToTop();
  }, []);

  useEffect(() => {
    setSortedCountries(countryState.countries || []);
  }, [countryState.countries]);


  if (countryState.fetching || countryState.processing) {
    return <Loader active inline />;
  }

  if (countryState.message === "resource deleted successfully") {
    dispatch(fetchCountries(""));
  }

  const handleDeleteCountry = (country_id) => {
    dispatch(deleteCountry(country_id));
  };

  const handleSearchCountry = () => {
    dispatch(fetchCountries(getValues("searchWord")));
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearchCountry();
    }
  };

  const handleSort = (key) => {
    let direction = "asc";

    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }

    const sorted = [...sortedCountries].sort((a, b) => {
      if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
      if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
      return 0;
    });

    setSortedCountries(sorted);
    setSortConfig({ key, direction });
  };


  return (
    <>
      {countryState.error ? (
        <Message negative content={t(countryState.error)} />
      ) : (
        ""
      )}
      <Segment className="flex items-center justify-between">
        <HeaderCatalog title={t("country_title")} message={countryState.message} to="/countries_new" floated='left' />
        <Header as='h5' floated='right'>
          <Input type="text" placeholder={t("search") + "..."} action>
            <input name="searchWord" maxLength={100} onKeyDown={handleKeyDown} ref={register()} />
            <Button type="submit" onClick={() => handleSearchCountry()} icon="search" size="medium" />
          </Input>
        </Header>
      </Segment>

      <Table color="blue" striped>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>{t("country_name")} <a href="#" onClick={() => handleSort("name")}>  <Icon name='sort' /></a></Table.HeaderCell>
            <Table.HeaderCell>{t("country_code")} <a href="#" onClick={() => handleSort("code")}>  <Icon name='sort' /></a></Table.HeaderCell>
            <Table.HeaderCell>{t("country_andean_pact")} <a href="#" onClick={() => handleSort("andean_pact")}>  <Icon name='sort' /></a></Table.HeaderCell>
            <Table.HeaderCell></Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {sortedCountries.map((country) => (
            <Table.Row key={country.id}>
              <Table.Cell>{t(country.name)}</Table.Cell>
              <Table.Cell>{t(country.code)}</Table.Cell>
              <Table.Cell>{country.andean_pact ? t('yes') : t('not')}</Table.Cell>
              <Table.Cell collapsing>
                <Link to={`/countries/${country.id}`}><Button circular color='blue' icon='pencil alternate' /></Link>
                <Modal
                  trigger={
                    <Button circular color='red' icon='trash alternate' />
                  }
                  content={t("country_delete")}
                  actions={[
                    t("canceled_button"),
                    {
                      key: "eliminar",
                      content: t("delete_button"),
                      className: "delete_button icon_color",
                      onClick: () => handleDeleteCountry(country.id),
                    },
                  ]}
                  size="tiny"
                />
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </>
  );
}
